import { draftsInitialState } from "./draftLists/delListsDraftsListsState";
import { submitsInitialState } from "./submitLists/delListsSubmitListsState";
import { approvalsInitialState } from "./approvalLists/delListsApprovalListsState";
import { approvedInitialState } from "./approvedLists/delListsApprovedListsState";
import { delReportsListsInitialState } from "./delReportsLists/delListsDelReportsListsState";

import { makeDraftsActions } from "./draftLists/delListsDraftsListsActions";
import { makeSubmitsActions } from "./submitLists/delListsSubmitListsActions";
import { makeApprovalsActions } from "./approvalLists/delListsApprovalListsActions";
import { makeApprovedActions } from "./approvedLists/delListsApprovedListsActions";
import { makeDelReportsListsActions } from "./delReportsLists/delListsDelReportsListsActions";

export const createDelListsSlice = (set, get) => ({
  delLists: {
    isLoading: true,
    error: null,
    drafts: draftsInitialState,
    submits: submitsInitialState,
    approvals: approvalsInitialState,
    approved: approvedInitialState,
    delReportsLists: delReportsListsInitialState,
  },

  delListsActions: Object.freeze({
    // Fetch all first pages
    fetchInitialDelLists: async (employeeId, forceRefresh = false) => {
      if (forceRefresh) {
        set((s) => ({
          delLists: {
            ...s.delLists,
            drafts: { ...s.delLists.drafts, currentPage: 1 },
            submits: { ...s.delLists.submits, currentPage: 1 },
            approvals: { ...s.delLists.approvals, currentPage: 1 },
            approved: { ...s.delLists.approved, currentPage: 1 },
            delReportsLists: { ...s.delLists.delReportsLists, currentPage: 1 },
          },
        }));
      }

      set((s) => ({
        delLists: { ...s.delLists, isLoading: true, error: null },
      }));

      try {
        const { fetchDraftsPage } = get().delListsActions;
        const { fetchSubmitsPage } = get().delListsActions;
        const { fetchApprovalsPage } = get().delListsActions;
        const { fetchApprovedPage } = get().delListsActions;
        const { fetchDelReportsPage } = get().delListsActions;
        await Promise.all([
          fetchDraftsPage(employeeId),
          fetchSubmitsPage(employeeId),
          fetchApprovalsPage(employeeId),
          fetchApprovedPage(employeeId),
          fetchDelReportsPage(),
        ]);

        set((s) => ({ delLists: { ...s.delLists, isLoading: false } }));
      } catch (err) {
        set((s) => ({
          delLists: {
            ...s.delLists,
            isLoading: false,
            error: err.message,
          },
        }));
      }
    },

    // Tab specific actions
    ...makeDraftsActions(set, get),
    ...makeSubmitsActions(set, get),
    ...makeApprovalsActions(set, get),
    ...makeApprovedActions(set, get),
    ...makeDelReportsListsActions(set, get),
  }),
});
